import { render, staticRenderFns } from "./AgregarArchivoCuentaCobro.vue?vue&type=template&id=38e5088e&scoped=true"
import script from "./AgregarArchivoCuentaCobro.vue?vue&type=script&lang=js"
export * from "./AgregarArchivoCuentaCobro.vue?vue&type=script&lang=js"
import style0 from "./AgregarArchivoCuentaCobro.vue?vue&type=style&index=0&id=38e5088e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e5088e",
  null
  
)

export default component.exports